import { ModalRenameComponent } from './../modal-rename/modal-rename.component';
import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ModalResetPasswordComponent } from '../modal-reset-password/modal-reset-password.component';
import { ModalNewProjectComponent } from '../modal-new-project/modal-new-project.component';
import { AuthService } from '../../../services/auth.service';
import { User } from '../../../user/user';
import { StageService } from '../../../services/stage.service';
import { BuildFloorService } from '../../../services/build-floor.service';
import { ProjectManagerService } from '../../../services/project-manager.service';
import { ModalDeleteComponent } from '../modal-delete/modal-delete.component';
import { SnapShotService } from '../../../services/snap-shot.service';
import { DeckHeightService } from '../../../services/deck-height.service';
import { ProductsService } from '../../../services/products.service';
import { Model3DService } from '../../../services/model3-d.service';
import { LoadingSpinnerService } from '../../../services/loading-spinner.service';
import { SetMaterialsService } from '../../../services/set-materials.service';
import { AppSettingsService } from '../../../services/app-settings.service';
import { SceneryService } from '../../../services/scenery.service';
import { DataForDisplayingMenuItemsService } from '../../../services/data-for-displaying-menu-items.service';
import { DockModeService } from '../../../services/dock-mode.service';
import { Project } from '../../../classes/project';
import { ToasterService } from 'angular2-toaster';
import { ModalSaveComponent } from '../modal-save/modal-save.component';
import { RailingGenerationService } from '../../../services/railing/services/railing-generation.service';
import { ConstantsService } from '../../../services/constants.service';
import { Location } from '@angular/common';
import { ViewSwitcherService } from '../../../services/view-switcher.service';
import { ProToolsUiManagerService } from '../../../services/pro-tools-ui-manager.service';
import { CookieServiceService } from '../../../services/cookie-service.service';
import { CameraService } from '../../../services/camera.service';
import { ZoomService } from '../../../services/zoom.service';
import { DrawTitleBlockComponent } from '../../../services/proTools/components/DrawTitleBlockComponent';
import { RailingColorsService } from '../../../services/railing/services/railing-colors.service';
import { RoomStateManagerService } from '../../../services/room-state-manager.service';
import { DoneShapeTemplatesService } from '../../../services/done-shape-templates.service';
import { AnalyticsService } from '../../../services/analytics.service';
import { AddonManagerService } from '../../../services/addon-manager.service';
import { AddonTemplate } from '../../../classes/addonTemplate';
import { Addon } from '../../../classes/addon';
import { environment } from '../../../../environments/environment';

declare let THREE: any;

// export class BarProxyComponent {
//   constructor(
//     private _router: Router,
//     private _route: ActivatedRoute
//   ) {
//     _router.navigate(['http://68.183.30.252:3079/' + _route.snapshot.params['id'], {mode: 'test'}]);
//   }
// }

@Component({
  selector: 'app-modal-start-screen',
  templateUrl: './modal-start-screen.component.html',
  styleUrls: ['./modal-start-screen.component.scss']
})
export class ModalStartScreenComponent implements OnInit {
  private URL: string = environment.addonUrl;
  currentProject: Project;
  currentAddonTemplate: AddonTemplate;
  isItForSharing: boolean = false;
  isAuthorization: boolean;
  isCreateAccount: boolean = false;
  isTabUserProject: boolean = false;
  isTabAddon: boolean = false;
  isTabDockRail: boolean = false;
  selectedIndex: number = -1; // for css class
  // "Start DockRail" tab (spec p.10): 'Create your own' (null) + 7 pre-designed docks
  dockTemplates = [
    { key: 'dock_straight', title: 'Straight Dock' },
    { key: 'dock_l', title: 'L-Shape Dock' },
    { key: 'dock_f', title: 'F-Shape Dock' },
    { key: 'dock_t', title: 'T-Shape Dock' },
    { key: 'dock_u', title: 'U-Shape Dock' },
    { key: 'dock_platform', title: 'Platform Dock' },
    { key: 'dock_slip', title: 'Slip Dock' }
  ];
  selectedDockShape: string = null;
  newUser: FormGroup;
  email: string;
  password: string;
  templates: Project[];
  projects: Project[];
  addonTemplates: AddonTemplate[];
  addons: Addon[];
  projectsAndAddons: any[] = [];
  authFromSave: boolean;
  firstName: string = 'User';
  currentStep: number;
  sceneNames: Array<any> = [
    'Rectangular',
    'Two-tiered deck',
    'Just for fun',
    'Second story corner',
    'Front Porch',
    'Angled corner attached',
    'U-shape attached'
  ];
  newTemplates: Project[];
  startProjFromTemplate: boolean = false;
  openSaved: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<ModalStartScreenComponent>,
    public dialog: MatDialog,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private auth: AuthService,
    private stage: StageService,
    private buildFloor: BuildFloorService,
    private newProject: ProjectManagerService, // bad naming
    private projectSrvc: ProjectManagerService,
    private snapshotSrvc: SnapShotService,
    private deckHeightService: DeckHeightService,
    private productSrvc: ProductsService,
    private model3D: Model3DService,
    private loadingSpinnerService: LoadingSpinnerService,
    private setMaterialService: SetMaterialsService,
    private appSettingsService: AppSettingsService,
    private sceneryService: SceneryService,
    private dataForDisplayingMenuItemsService: DataForDisplayingMenuItemsService,
    private dockModeService: DockModeService,
    private toasterService: ToasterService,
    private railingGenerationService: RailingGenerationService,
    private buildFloorService: BuildFloorService,
    private constants: ConstantsService,
    private location: Location,
    private viewSwitcher: ViewSwitcherService,
    private proToolsUiManagerService: ProToolsUiManagerService,
    private cookieServiceService: CookieServiceService,
    private cameraService: CameraService,
    private zoomService: ZoomService,
    private drawTitleBlock: DrawTitleBlockComponent,
    private railingColorsService: RailingColorsService,
    private roomStateManager: RoomStateManagerService,
    private shapeTemplates: DoneShapeTemplatesService,
    private analyticsService: AnalyticsService,
    private router: Router,
    private route: ActivatedRoute,
    private addonService: AddonManagerService
  ) {
    if (
      data &&
      (data === 'login-for-sharing' || data === 'login-for-print' || data === 'login-for-ai-snapshot')
    ) {
      this.isItForSharing = true;
    }
  }

  closeDialog() {
    this.dialogRef.close();
  }

  getProjs(ids, index, projs) {
    this.projectSrvc.getProject(ids[index]).subscribe(prj => {
      index++;
      projs.push(prj);
      if (ids.length === projs.length) {
        this.newTemplates = projs;
      } else {
        this.getProjs(ids, index, projs);
      }
    });
  }

  ngOnInit() {
    this.projectSrvc.getTemplates().subscribe(temp => {
      this.templates = temp;
      // this.templates.length = 7;
    });

    this.addonService.getDataFromLocalJSON().subscribe(result => {
      if (result && result.data) {
        // console.log('result.data', result.data);
        this.addonTemplates = result.data[0].scenes; // get from cms3
        // this.addonTemplates = JSON.parse(result.data[0].scene3d); // get from cms2
        // console.log(JSON.parse(result.data[0].scene3d));
      }
    });

    // this.addonService.getDataFromCms().subscribe(result => {
    //     if (result && result.data) {
    //       // console.log('result.data', result.data);
    //       this.addonTemplates = result.data[0].scenes; // get from cms3
    //       // this.addonTemplates = JSON.parse(result.data[0].scene3d); // get from cms2
    //       // console.log(JSON.parse(result.data[0].scene3d));
    //     }
    // });

    this.data === 'OPEN' ? (this.isTabUserProject = true) : (this.isTabUserProject = false);

    const isAuthorization = JSON.parse(sessionStorage.getItem('isAuthorization'));
    this.isAuthorization = isAuthorization;
    if (this.isAuthorization) {
      this.signInIfAuth(sessionStorage.getItem('token'));
    }

    if (this.isAuthorization === true) {
      if (this.auth.getRole() === 'admin') {
        this.newProject.getTemplates().subscribe(temps => (this.projects = temps));
      } else {
        this.projectsAndAddons = [];
        this.getProjects(174);
        this.getAddons();
      }
    }

    if (
      this.data === 'login' ||
      this.data === 'login-for-sharing' ||
      this.data === 'login-for-print' ||
      this.data === 'login-for-ai-snapshot'
    ) {
      this.toggleTab('user-projects');
    } else if (this.data === 'register') {
      this.toggleTab('user-projects');
      this.isCreateAccount = true;
    } else if (this.data === 'editProfile') {
      this.toggleTab('user-projects');
      this.isCreateAccount = true;
    }

    this.auth.isAuthorization.subscribe(auth => {
      this.isAuthorization = auth;
    });

    this.currentStep = this.dataForDisplayingMenuItemsService.getCurrentStep();

    // ?mode=dockrail deep link: open straight onto the DockRail tab
    if (this.dockModeService.isDockMode()) {
      this.toggleTab('dockrail');
    }
  }

  getProjects(row) {
    this.newProject.getProjects().subscribe(prjs => {
      this.projects = prjs;
      this.fullingProjectsAndAddonsArrayByProjectIncludingChecking(prjs, row);
    });
  }

  getAddons() {
    this.addonService.getAddonProjects(this.auth.userId).subscribe(addons => {
      this.addons = addons || [];
      // console.log('addons1', this.addons);
      if (!this.addons.length) {
        this.addonService.getAllAddonProjectsByUserId(this.auth.userId).subscribe(addons2 => {
          this.addons = addons2 || [];
          // console.log('addons2', this.addons);
          this.fullingProjectsAndAddonsArrayByProjectIncludingChecking(addons2);
        });
      } else {
        this.fullingProjectsAndAddonsArrayByProjectIncludingChecking(addons);
      }
    });
  }

  fullingProjectsAndAddonsArrayByProjectIncludingChecking(array, row = '') {
    array.forEach(el1 => {
      const prj = this.projectsAndAddons.find(el2 => el1.id === el2.id);
      if (!prj) {
        // console.log('prj', row, prj);
        this.projectsAndAddons = [...this.projectsAndAddons, el1]
          .sort((a, b) => new Date(b.updated).getTime() - new Date(a.updated).getTime());
      }
    });
  }

  shortName(name: string) {
    if (name && name.length > 15) {
      return Array.prototype.slice.call(name, 0, 20).join('') + '...';
    }
    return name;
  }

  setCurrentProject(temp: Project): void {
    // console.log('temp', temp);
    this.currentProject = temp;
  }

  setCurrentAddon(temp: AddonTemplate): void {
    this.currentAddonTemplate = temp;
  }

  startProject(): void {
    // console.log('this.currentProject', this.currentProject);
    // deck starts only — DockRail has its own tab (startDockRail)
    this.dockModeService.setDockMode(false);
    this.drawTitleBlock.clearTitleBlock();
    // this.viewSwitcher.to2D();
    // this.proToolsUiManagerService.proToolsModActive.next(true);

    // this.viewSwitcher.switchView(true); // duplicates switchTo2D() call

    let cookie = this.cookieServiceService.getCookie('test1');

    this.viewSwitcher.needViewModeIconUpdate.next(false);
    // if (this.selectedIndex === -1) {
    //   this.viewSwitcher.needViewModeIconUpdate.next(false);
    // } else {
    //   this.viewSwitcher.needViewModeIconUpdate.next(true);
    // }

    this.buildFloor.removeFloor();
    this.buildFloor.setCompundFloorPosY(this.constants.deckHeight);
    this.projectSrvc.setIsSavedProject(false);
    this.projectSrvc.resetProject();
    this.projectSrvc.setSharedProjID(null);
    this.snapshotSrvc.setSnapshots([]);

    if (this.selectedIndex === -1) {
      this.railingGenerationService.buildRailingIfVisible();
      if (this.currentStep === 1) {
        this.dataForDisplayingMenuItemsService.firstStepChange.next(true);
        this.railingGenerationService.isVisible = false;
      }
      const dialogRef = this.dialog.open(ModalNewProjectComponent, {
        width: '600px',
        data: 'Data'
      });

      dialogRef.afterClosed().subscribe(result => {
        // console.log('New project dialog was closed');
      });
    } else {
      this.dataForDisplayingMenuItemsService.setProToolsResetProj();
      // this.roomStateManager.setPoints(this.currentProject.points);
      this.dataForDisplayingMenuItemsService.startNewProject();
      this.deckHeightService.setDeckHeight(this.currentProject.deckHeight || 8);
      this.sceneryService.change('grid');
      this.buildFloor.removeFloor();
      this.projectSrvc.setDeckMaterial(this.currentProject.deckMaterial);
      this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
      this.buildFloorService.setCompundFloorPosY(this.currentProject.deckHeight * 2.54);
      this.buildFloors(this.currentProject.tiers);
      if (this.currentProject.accessories) {
        this.buildAccessories(this.currentProject.accessories);
      }
      if (this.currentProject.scenery) {
        this.sceneryService.change(Object.values(this.currentProject.scenery).join(''));
      }
      if (this.currentProject.railing) {
        this.dataForDisplayingMenuItemsService.setCurrentParams(this.currentProject.railing);
        this.dataForDisplayingMenuItemsService.setDefaultParams();
      }
      this.projectSrvc.setProjectType('home');
      if (this.currentStep === 1) {
        this.dataForDisplayingMenuItemsService.firstStepChange.next(false);
      }
    }
    this.location.replaceState('');
    this.viewSwitcher.switchView(false);
    this.cameraService.reset();
    this.zoomService.reset();
    if (this.startProjFromTemplate || this.openSaved) {
      this.railingGenerationService.buildRailing(true);
    }

    if (this.startProjFromTemplate) {
      // console.log('this.currentProject', this.currentProject);
      this.analyticsService.onUserChoosedScene(
        this.currentProject.projectName,
        this.currentProject.id
      );
    }

    if (this.dataForDisplayingMenuItemsService.projectColorsExist(this.currentProject)) {
      this.dataForDisplayingMenuItemsService.setProjectColors(this.currentProject);
    } else {
      this.dataForDisplayingMenuItemsService.setDeafaultColors();
    }
  }

  openRenameDialog(prj: Project): void {
    const dialogRef = this.dialog.open(ModalRenameComponent, {
      width: '455px',
      data: { project: prj }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Rename dialog was closed');
      if (this.isAuthorization === true) {
        if (this.auth.getRole() === 'admin') {
          this.newProject.getTemplates().subscribe(temps => (this.projects = temps));
        } else {
          this.projectsAndAddons = [];
          this.getProjects(338);
          this.getAddons();
        }
      }
    });
  }

  openDeleteDialog(prj: Project): void {
    const dialogRef = this.dialog.open(ModalDeleteComponent, {
      width: '455px',
      data: { project: prj }
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Delete dialog was closed');
      if (this.isAuthorization === true) {
        if (this.auth.getRole() === 'admin') {
          this.newProject.getTemplates().subscribe(temps => (this.projects = temps));
        } else {
          this.projectsAndAddons = [];
          this.getProjects(358);
          this.getAddons();
        }
      }
    });
  }

  toggleTab(tab: string) {
    this.isTabDockRail = tab === 'dockrail';
    if (tab === 'new-projects' || tab === 'dockrail') {
      this.isCreateAccount = false;
      this.isTabUserProject = false;
      this.isTabAddon = false;
    }
    if (tab === 'user-projects') {
      this.isTabUserProject = true;
      this.isTabAddon = false;
    }
    if (tab === 'addon') {
      this.isTabUserProject = false;
      this.isTabAddon = true;
    }
  }

  selectAddon(id) {

  }

  goToAddon(typeProject = '') {
    console.log('this.currentProject', this.currentProject);
    let currentAddonId = this.currentAddonTemplate ? this.currentAddonTemplate.id : '';
    let projectAddonId = this.currentProject ? this.currentProject.id : '';
    if (typeProject === 'template') {
      projectAddonId = '';
    } else {
      currentAddonId = '';
    }
    const userId = this.auth.userId ? this.auth.userId : '';
    const token = this.auth.token ? this.auth.token : '';
    let hashToken = '';
    if (userId && token) {
      hashToken = this.hashToken(token);
    }
    const newURL = `${this.URL}/addons/?userId=${userId}&token=${token}&sceneId=${currentAddonId}&projectId=${projectAddonId}`;
    window.location.href = newURL;
      // this.router.navigate(['http://68.183.30.252:3079/' + this.auth.userId]);
      // this.router.navigate(['http://68.183.30.252:3079/' + this.route.snapshot.params['id'], { mode: this.auth.userId }]);
  }

  hashToken(token) {
    const hashTokenArray = token.split('');
    const newHashTokenArray = ['q1E', ...hashTokenArray];
    const hashToken = newHashTokenArray.join('');
    return hashToken;
  }

  startFromTemplate() {
    if (this.selectedIndex !== -1) {
      this.startProjFromTemplate = true;
    }
  }

  // "Start DockRail" tab (spec p.10): 'Create your own' opens the dock New
  // Project dialog; a template tile builds the chosen dock right away (same
  // steps as ModalNewProjectComponent.checkDeckShape for a dock shape).
  startDockRail(): void {
    this.dockModeService.setDockMode(true);
    this.drawTitleBlock.clearTitleBlock();
    this.viewSwitcher.needViewModeIconUpdate.next(false);

    this.buildFloor.removeFloor();
    this.buildFloor.setCompundFloorPosY(this.constants.deckHeight);
    this.projectSrvc.setIsSavedProject(false);
    this.projectSrvc.resetProject();
    this.projectSrvc.setSharedProjID(null);
    this.snapshotSrvc.setSnapshots([]);

    // remove any existing (deck) railing instead of rebuilding it: an async
    // rebuild here races with the project reset below (deleteColors) and
    // crashes in the colors service once the old models finish loading
    this.railingGenerationService.buildRailing(false);
    if (this.currentStep === 1) {
      this.dataForDisplayingMenuItemsService.firstStepChange.next(true);
    }

    if (!this.selectedDockShape) {
      const dialogRef = this.dialog.open(ModalNewProjectComponent, {
        width: '600px',
        data: 'Data'
      });
      dialogRef.afterClosed().subscribe(() => {});
      return;
    }

    this.dataForDisplayingMenuItemsService.setProToolsResetProj();
    // projectType must be 'dock' BEFORE startNewProject(): setDefaultParams()
    // inside it branches on the project type to pick the DockRail defaults
    this.projectSrvc.setProjectType(DockModeService.PROJECT_TYPE);
    this.projectSrvc.setDockSubtype('home');
    this.dataForDisplayingMenuItemsService.startNewProject();
    // noRail: dock sides start without railing — anchors on the railing step
    // (spec pp.13-15) add it side by side
    const template = this.shapeTemplates.shapes[this.selectedDockShape].map(p =>
      Object.assign({}, p, { noRail: true })
    );
    this.roomStateManager.setPoints(template);
    this.sceneryService.change('lakefront');
    this.buildFloor.setCompundFloorPosY(53.34);
    this.buildFloor.buildFloor({ points: template, height: 53.34, mainFloor: true });
    this.deckHeightService.setDeckHeight(21);
    this.railingGenerationService.buildRailing(false);
    this.cameraService.reset();
    this.zoomService.reset();
  }

  signInIfAuth(JSONtoken) {
    const token = JSON.parse(JSONtoken);
    this.auth.setToken(token.id);
    this.auth.setUser(token.user);

    if (token.hasOwnProperty('userId')) {
      if (token.hasOwnProperty('role')) {
        this.auth.setRole(token.role.name);
      } else {
        this.auth.setRole('user');
      }
      // console.log('Sign in: isAuthorization = true');
      this.auth.setIsAuthorization(true);
      this.firstName = token.user.firstName;

      this.auth.setEmail(token.user.email);
      this.auth.setUserId(token.userId);
      /*sessionStorage.setItem('token', JSON.stringify(token));
      sessionStorage.setItem('isAuthorization', JSON.stringify(this.isAuthorization))*/

      if (this.auth.getRole() === 'admin') {
        this.projects = this.templates;
      } else if (this.auth.getRole() === 'user' || this.auth.getRole() === 'salesManager') {
        this.newProject.setUserId(token.userId);
        this.projectsAndAddons = [];
        this.getProjects(443);
        this.getAddons();
      }
    }
    this.auth.isAuthorization.subscribe(auth => (this.isAuthorization = auth));
  }

  openResetPasswordDialog(): void {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(ModalResetPasswordComponent, {
      width: '400px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Reset password dialog was closed');
    });
  }

  openNewProjectDialog(): void {
    const dialogRef = this.dialog.open(ModalNewProjectComponent, {
      width: '600px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('New project dialog was closed');
    });
  }

  async openProject() {
    if (this.currentProject.projectType !== 'interior') {
      this.dockModeService.setDockModeFromProjectType(this.currentProject.projectType);
      this.dataForDisplayingMenuItemsService.setProToolsResetProj();
      this.openSaved = true;
      this.drawTitleBlock.clearTitleBlock();

      // this.viewSwitcher.to3D();

      // this.viewSwitcher.switchView(false); // duplicates switchTo2D() call
      this.viewSwitcher.needViewModeIconUpdate.next(false);

      // this.proToolsUiManagerService.proToolsModActive.next(false);

      if (this.auth.getRole() !== 'admin') {
        this.snapshotSrvc.setSnapshots(this.currentProject.snapshots);
      }
      this.snapshotSrvc.setSnapshotsProTools(this.currentProject.snapshotsProTools);
      this.buildFloor.removeFloor();
      this.projectSrvc.setProject(this.currentProject);
      this.projectSrvc.setIsSavedProject(true);
      this.projectSrvc.setSharedProjID(null);
      this.buildFloorService.setCompundFloorPosY(this.currentProject.deckHeight * 2.54);
      this.deckHeightService.setDeckHeight(this.currentProject.deckHeight || 8);
      this.setMaterialService.setMaterial(this.currentProject.deckMaterial);
      this.buildFloors(this.currentProject.tiers);
      this.buildAccessories(this.currentProject.accessories);
      this.appSettingsService.setScenery(this.currentProject.scenery);
      this.sceneryService.change(this.currentProject.scenery);
      this.dataForDisplayingMenuItemsService.setCurrentParams(this.currentProject.railing);

      await this.railingGenerationService.buildRailing(true);
      if (this.currentStep === 2) {
        await this.railingGenerationService.buildRailingIfVisible();
      } else {
        this.dataForDisplayingMenuItemsService.firstStepChange.next(true);
      }

      if (this.dataForDisplayingMenuItemsService.projectColorsExist()) {
        this.dataForDisplayingMenuItemsService.setProjectColors();
      } else {
        this.dataForDisplayingMenuItemsService.setDeafaultColors();
      }

      this.dataForDisplayingMenuItemsService.setProjectLighting();
      // this.dataForDisplayingMenuItemsService.setDeafaultColors();
      // this.railingColorsService.updateColorMap(this.dataForDisplayingMenuItemsService.currentColors);
      this.location.replaceState('');
    } else {
      this.goToAddon();
    }

  }

  buildFloors(tiers: any[]): void {
    for (const tier of tiers) {
      this.buildFloor.buildFloor({
        points: tier.points,
        height: tier.height,
        mainFloor: tier.mainFloor,
        customId: tier.customId,
        parentCustomId: tier.parentCustomId
      });
    }
  }

  // to do refactor
  // this code is present in 2 places
  buildAccessories(accessories): void {
    for (let accessory of accessories) {
      this.productSrvc.getAccessories().then(accessories => {
        const activeEntity = accessories.find(a => a.id === accessory.id);
        const rotation = new THREE.Euler(
          accessory.rotation.x,
          accessory.rotation.y,
          accessory.rotation.z,
          'XYZ'
        );
        this.loadingSpinnerService.spinnerLoadingListAdd('buildAccessories' + accessory.id);
        this.model3D
          .create(activeEntity, {
            position: accessory.position,
            rotation: rotation,
            wall: null,
            show3DObject: true
          })
          .then(obj => {
            // obj.userData.boundingBox = boundingBox;
            obj.userData.entity = activeEntity;
            obj.name = activeEntity.productType;
            const tiers = this.stage.getCompoundFloor().children;
            const tier = tiers.find(t => t.userData.customId === accessory.parentId);
            if (tier) {
              tier.updateMatrixWorld(true);
              obj.updateMatrixWorld(true);
              this.stage.getScene().updateMatrixWorld(true);
              THREE.SceneUtils.attach(obj, this.stage.getScene(), tier);
            }
            this.loadingSpinnerService.spinnerLoadingListRemove('buildAccessories' + accessory.id);
          });
      });
    }
  }

  onResetPasswordDialog() {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(ModalResetPasswordComponent, {
      width: '400px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(result => {
      // console.log('Reset password dialog was closed');
    });
  }

  onLoginSuccess(token) {
    if (this.auth.getRole() === 'admin') {
      this.projects = this.templates;
    } else if (this.auth.getRole() === 'user' || this.auth.getRole() === 'salesManager') {
      this.newProject.setUserId(token.userId);
      this.projectsAndAddons = [];
      this.getProjects(594);
      this.getAddons();
    }
    if (this.auth.authToSave) {
      this.dialogRef.close();
      this.auth.triggerAuthToSave();
      this.dialog.open(ModalSaveComponent, {
        width: '455px',
        data: 'Data'
      });
    }
    if (this.isItForSharing) {
      this.dialogRef.close();
    }
  }

  onCreateANewAccount() {
    this.isCreateAccount = true;
  }

  onUserUpdate() {
    this.dialogRef.close();
  }

  onUserRegister() {
    this.isAuthorization = false;
    this.isCreateAccount = false;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-start-screen/modal-start-screen.component.ts